<template>
  <div class="leaflet-popup-content">
    <h5 v-if="title" class="text-center">
      {{ title }}
    </h5>

    <div v-for="(item, index) in rowsFormatted" class="details-row" :key="`row-${index}`">
      <div>{{ item.name || '--' }}</div>
      <div>{{ item.value || '--' }}</div>
    </div>

    <div class="popup-extras">
      <b-link
        @click="$emit('show-voyages', itemId)"
        class="popup-extras__link">
        Show Vessel Voyages
      </b-link>

      <b-link
        @click="$emit('show-tracks', itemId)"
        class="popup-extras__link">
        Show Vessel Tracks
      </b-link>

      <!-- todo: fix empty data in other maps, vessel positioning in vessel-details  -->
      <router-link
        class="popup-extras__link"
        :to="{ name: 'Vessel Details', query: { imo: itemId } }">
        Show Vessel Details
      </router-link>
    </div>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import getNested from 'lodash/get';

export default {
  name: 'canvas-map-popup-content',

  props: {
    title: {
      // optional
      type: String,
      default: null,
    },

    itemId: {
      // optional, could be used to handle links clicking, etc
      default: 'emptyId',
    },

    popupOptions: {
      type: Object,
      default: () => ({}),
    },

    rowsBasic: {
      // example:
      // [{name: 'Vessel name', value: 'Triton'}, ... ]
      // or {"Field Name": <field_value>}
      // note: js preserves object insertion order when keys are strings
      default: () => [],
    },
  },

  computed: {
    rows() {
      if (isEmpty(this.rowsFull)) {
        return this.rowsBasic;
      } else {
        return this.rowsFull;
      }
    },

    rowsFull() {
      return getNested(this.$store, 'state.map.selectedVesselDetails.popupData', {});
    },

    rowsFormatted() {
      // it's possible to have object or array as input prop "rows"
      if(Array.isArray(this.rows)) {
        return this.rows;
      } else if(typeof this.rows === 'object') {
        return Object.keys(this.rows).map(fieldTitle => ({
          name: fieldTitle,
          value: this.rows[fieldTitle],
        }));
      } else {
        return [];
      }
    },
  },
}
</script>

<style scoped lang="scss">
  // additional styles for a vessel popup
  .popup-extras {
    margin-top: 15px;

    &__link {
      display: block;
      margin-top: 5px;
      text-align: center;
      font-size: 16px;
    }
  }
</style>
